import React, {useRef, useEffect} from 'react'
import {graphql} from 'gatsby'
import './SpecialContent.scss'

const List = ({listTitle, list}) => {
	return(
		<div className="SpecialContent-List">
			<h2 dangerouslySetInnerHTML={{__html: listTitle}} />
			<ul>
				{
					list.map((item, i) => <li key={`listItem${i}`} className={`listItem ${item.icon}`}>{item.text}</li>)
				}
			</ul>
		</div>
	)
}

const Video = ({file}) => {

	const video = useRef(null);
	const container = useRef(null);

	useEffect(() => {

		const observerFunction = (entries) => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					if(video !== null) {
						video.current.play();
					}
				}
			})
		}

		const observer = new IntersectionObserver(observerFunction, {
			rootMargin: '0px 0px -55%'
		});

		if(container !== null) {
			observer.observe(container.current);
		}

	});

	return(
		<div className="SpecialContent-Video" ref={container}>
			<video muted playsInline ref={video}>
				<source src={file} />
			</video>
		</div>
	)
}

export default function SpecialContent({title, leadParagraph, content, listTitle, list, video}) {

	return (
		<>
		<div className="SpecialContent">
			<div className="inner">
				<div className="header">
					{ title && <h1 dangerouslySetInnerHTML={{__html: title}} /> }
					{ leadParagraph && <p className="lead" dangerouslySetInnerHTML={{__html: leadParagraph}} /> }
					{list && listTitle && <List listTitle={listTitle} list={list} /> }
					{ content && <div className="text" dangerouslySetInnerHTML={{__html: content}} /> }
				</div>
			</div>
		</div>
			{
				video && video.localFile
				&& <Video file={video.localFile.publicURL} />
			}
		</>
	)
}

export const query = graphql`
	fragment SpecialContent on WpPage_Layout_block_Layout_SpecialContent {
		fieldGroupName
		title
		leadParagraph
		listTitle
		list {
			icon
			text
		}
		content
		video {
			localFile {
				publicURL
			}
		}
	}
`